import router, { resetRouter } from './router'
// import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { mapRoutes } from '@/utils/route'
import { addMeta } from '@/utils/index'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)
  // 获取系统基础配置
  const hasBasicSettings =
    store.getters.basicSettings &&
    Object.keys(store.getters.basicSettings).length > 0
  if (to.params.project) {
    store.commit('user/SET_USER_TYPE', 'corp')
    store.commit('user/SET_PROJECT_CODE', to.params.project)
  }
  if (!hasBasicSettings) {
    if (store.getters.user.code) {
      to.params.project = store.getters.user.code
    }
    const res = await store.dispatch('settings/getBasicSettings', to.params)
    const { site_name, site_seo_keywords, site_seo_description } = res

    store.dispatch('app/setSiteConf', res)
    document.title = getPageTitle(to.meta.title, site_name)
    addMeta('keywords', site_seo_keywords)
    addMeta('description', site_seo_description)
  }
  // 获取系统安全配置
  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login' || to.name === 'tenant-login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles, routes } = await store.dispatch('user/getInfo')
          const remoteRoutes = mapRoutes(routes)
          // 路由末尾增加404页
          remoteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch(
            'permission/generateRoutes',
            { roles, remoteRoutes }
          )
          resetRouter()
          // console.log('accessRoutes:', accessRoutes)
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          const code = store.getters.user.code || to.params.project
          if (code) {
            next(`/project/${code}/login?redirect=${to.path}`)
          } else {
            next(`/login?redirect=${to.path}`)
          }

          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1 || to.name === 'tenant-login' || to.name === 'help') {
      // in the free login whitelist, go directly
      next()
    } else {
      const code = store.getters.user.code || to.params.project
      // other pages that do not have permission to access are redirected to the login page.
      if (code) {
        next(`/project/${code}/login?redirect=${to.path}`)
      } else {
        next(`/login?redirect=${to.path}`)
      }
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
